<template>
<div>
    <b-tabs pills vertical>
        <b-tab title="Partial and exact Match" style="height:calc(100vh - 200px);overflow-y:auto;">
            <b-card class="text-left">

                <h3>Country</h3>
                <h3>Country Exact Match <small class="text-muted">{{openCorporateData.countryExactMatchTotals.nameSearched}}</small></h3>
                Country code: {{openCorporateData.countryExactMatchTotals.countryCode}}
                <!-- <pre class="text-left">{{openCorporateData.countryExactMatchTotals && openCorporateData.countryExactMatchTotals.data || ''}}</pre> -->
                <p>Number of results: {{openCorporateData.countryExactMatchTotals.data.total_count}} / {{new Intl.NumberFormat().format( openCorporateData.numberCompaniesInCountry.data.total_count)}}</p>
                <h3>Country Partial Match <small class="text-muted">{{openCorporateData.countryPartialMatchTotals.nameSearched}}</small></h3>
                <!-- <pre class="text-left">{{openCorporateData.countryPartialMatchTotals && openCorporateData.countryPartialMatchTotals.data || ''}}</pre> -->
                <p>Number of results: {{openCorporateData.countryPartialMatchTotals.data.total_count}} / {{new Intl.NumberFormat().format( openCorporateData.numberCompaniesInCountry.data.total_count)}}</p>
                    
                    
                    <h3>Global</h3>
            <h3>Global Exact Match <small class="text-muted">{{openCorporateData.globalExactMatchTotals.nameSearched}}</small></h3>
                
                <p>Number of results: {{openCorporateData.globalExactMatchTotals.data.total_count}} / 183,931,900</p>
                
                <h3>Global Partial Match <small class="text-muted">{{openCorporateData.globalPartialMatchTotals.nameSearched}}</small></h3>
                <p>Number of results: {{openCorporateData.globalPartialMatchTotals.data.total_count}} / 183,931,900</p>
                <!-- <pre class="text-left">{{openCorporateData.globalPartialMatchTotals && openCorporateData.globalPartialMatchTotals.data || ''}}</pre> -->
                
                Country code: {{openCorporateData.countryPartialMatchTotals.countryCode}}

                <!-- <h3>Total Companies in the country <small class="text-muted">{{openCorporateData.numberCompaniesInCountry &&  new Intl.NumberFormat().format( openCorporateData.numberCompaniesInCountry.data.total_count)}}</small></h3> -->
                
                
            </b-card>
        </b-tab>
        <b-tab title="Details" style="height:calc(100vh - 200px);overflow-y:auto;" v-if="openCorporateData.companyDataWithRegistrationNumber && openCorporateData.companyDataWithRegistrationNumber.name">
            <b-card class="text-left">
                <p>
                    <span>
                        <strong>Name:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.name || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Terms:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.source && openCorporateData.companyDataWithRegistrationNumber.source.terms || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Publisher:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.source && openCorporateData.companyDataWithRegistrationNumber.source.publisher || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Company Type:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.company_type || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Company Number:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.company_number || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Registered Address:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.registered_address_in_full || 'Not Available'}}</span>
                </p>

                <p>
                    <span>
                        <strong>Current Status:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.current_status || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Disovled date:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.dissolution_date || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Controlling Entity:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.controlling_entity || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Incorporation date:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.incorporation_date || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Number Of Employees:</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.number_of_employees || 'Not Available'}}</span>
                </p>
                <p>
                    <span>
                        <strong>Beneficial Owners</strong>
                    </span>&nbsp;
                    <span>{{openCorporateData.companyDataWithRegistrationNumber.ultimate_beneficial_owners || 'Not Available'}}</span>
                </p>
            </b-card>
        </b-tab>
        <b-tab 
                :title="'Officers (' + (openCorporateData.companyDataWithRegistrationNumber.officers && openCorporateData.companyDataWithRegistrationNumber.officers.length) + ')'" 
                class="text-left" style="height:calc(100vh - 200px);overflow-y:auto;" 
                v-if="openCorporateData.companyDataWithRegistrationNumber && openCorporateData.companyDataWithRegistrationNumber.officers">
                <div v-if="openCorporateData.companyDataWithRegistrationNumber && openCorporateData.companyDataWithRegistrationNumber.officers">
                    <div>
                        <b-row>
                            <b-col cols="6" v-for="(officer,officerIndex) in openCorporateData.companyDataWithRegistrationNumber.officers" :key="officerIndex">
                                <b-card :header="'Officer '+(officerIndex + 1)" class="mb-3">
                                    
                                    <p>
                                        <span>
                                            <strong>Name:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.name || 'Not Available'}}</span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>Address:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.address || 'Not Available'}}</span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>Position:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.position || 'Not Available'}}</span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>Date Of Birth:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.date_of_birth || 'Not Available'}}</span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>Nationality:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.nationality || 'Not Available'}}</span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>Status:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.inactive || 'Not Available'}}</span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>Start Date:</strong>
                                        </span>&nbsp;
                                        <span>{{officer.officer.start_date || 'Not Available'}}</span>
                                    </p>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </div>
        </b-tab>
        <b-tab title="Filings" style="height:calc(100vh - 200px);overflow-y:auto;"  v-if="openCorporateData.companyDataWithRegistrationNumber && openCorporateData.companyDataWithRegistrationNumber.filings">
           
                <div v-if="openCorporateData.companyDataWithRegistrationNumber && openCorporateData.companyDataWithRegistrationNumber.filings">
                
                       <b-row>
                        <b-col cols="6" v-for="(filing,filingIndex) in openCorporateData.companyDataWithRegistrationNumber.filings" :key="filingIndex">
                            <b-card class="text-left mb-3">
                                <p>
                                    <span>
                                        <strong>Date:</strong>
                                    </span>&nbsp;
                                    <span>{{filing.filing.date || 'Not Available'}}</span>
                                </p>
                                <p>
                                    <span>
                                        <strong>Title:</strong>
                                    </span>&nbsp;
                                    <span>{{filing.filing.title || 'Not Available'}}</span>
                                </p>
                                <p>
                                    <span>
                                        <strong>Description:</strong>
                                    </span>&nbsp;
                                    <span>{{filing.filing.description || 'Not Available'}}</span>
                                </p>
                                <p>
                                    <span>
                                        <strong>Filing Type Code:</strong>
                                    </span>&nbsp;
                                    <span>{{filing.filing.filing_type_code || 'Not Available'}}</span>
                                </p>
                                <p>
                                    <span>
                                        <strong>Filing Type Name:</strong>
                                    </span>&nbsp;
                                    <span>{{filing.filing.filing_type_name || 'Not Available'}}</span>
                                </p>
                            </b-card>
                        </b-col>
                       </b-row>
                    </div>
             
           
        </b-tab>
        <b-tab title="Totals" v-if="openCorporateData.totals">
            <pre>
            {{openCorporateData.totals}}</pre>
        </b-tab>
    </b-tabs>
</div>
</template>

<script>
export default {
    name: "OpenCorporateDataComponent",
    data() {
        return {};
    },
    mounted() {
        // console.log('openCorporateData', this.openCorporateData);

    },
    computed: {},
    methods: {},
    props: {
        openCorporateData: Object
    }
};
</script>
